<tg-mobile-full-screen-dialog>
  <h1 class="title" i18n="Voters dialog|title @@votersDialog.title">
    Список проголосовавших
  </h1>

  <div style="min-height: 150px">
    @if (votersLoad && !voters) {
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        style="margin: 0 auto"
      ></mat-progress-spinner>
    }
    @if (voters) {
      <div>
        <h3 fxLayout="row" fxLayoutAlign="space-between center">
          <ng-container i18n="Voters dialog|text @@votersDialog.allCount">Всего проголосовало: {{ voters.count }}</ng-container>
          @if (voters.reactions) {
            <p>
              <mat-form-field>
                <mat-label i18n="Voters dialog|label @@votersDialog.selectReactionLabel">Реакции</mat-label>
                <mat-select (selectionChange)="filterVoters($event)">
                  <mat-option [value]="" selected i18n="Voters dialog|option @@votersDialog.allOption">Все</mat-option>
                  @for (react of voters.reactions; track react) {
                    <mat-option [value]="react.value">
                      {{ react.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </p>
          }
        </h3>
        <table>
          <thead>
            <tr>
              <th style="text-align: left">id</th>
              <th>name</th>
              <th>username</th>
              @if (voters.getChoice) {
                <th>choice</th>
              }
            </tr>
          </thead>
          @for (u of filterVotersByReaction(voters.items); track u) {
            @if (u) {
              <tr>
                <td width="100">{{ u.id }}</td>
                <td width="200">{{ u.first_name }} {{ u.last_name }}</td>
                <td>{{ u.username }}</td>
                @if (voters.getChoice) {
                  <td>{{ voters.getChoice(u.choice) }}</td>
                }
              </tr>
            }
          }
        </table>
      </div>
    }
  </div>
</tg-mobile-full-screen-dialog>
